<template>
    <b-container>
        <!-- Search & Create Preset -->
        <div class="row d-flex align-items-center justify-content-between py-3">
            <div class="min-w-25 search-container">
                <input type="text"
                       v-model="filter.search"
                       class="form-control focus:border-followup-nav"
                       placeholder="Search preset..."
                       @input="debounceFilter">
                <i class="fa fa-search text-primary"></i>
            </div>
            <div>
                <button type="button" class="btn btn-primary" @click="createPreset">
                    Create a new preset
                </button>
            </div>
        </div>

        <div>
            <!-- Preset List Loader -->
            <div v-if="presetsLoader" class="loader-overlay">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <!-- Presets List -->
            <div
                v-for="preset in presets"
                class="row d-flex align-items-center justify-content-between list-group-item text-grey-darkest">
                <div class="d-flex flex-column">
                    <div class="font-bold">{{ preset.name }} <span v-if="preset.is_default" class="badge badge-primary badge-sm">Default</span></div>
                    <div class="text-sm pt-2">Total Enabled Permissions: <span class="text-followup-nav">{{ preset.total_permissions }}</span></div>
                </div>
                <div class="d-flex align-items-center">
                    <button v-if="preset.name !== 'System Admin'" type="button" class="no-btn-properties" @click="editPreset(preset)">
                        <i class="fa fa-pencil text-grey-darkest"></i>
                    </button>
                    <button v-if="preset.name !== 'System Admin'" type="button" class="no-btn-properties pl-2" @click="deletePreset(preset)">
                        <i class="fa fa-trash text-danger"></i>
                    </button>
                </div>
            </div>
            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-content-center mt-5">
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last">
                </b-pagination>
            </div>
        </div>

        <!-- Create Edit Preset Modal -->
        <create-edit-preset-modal
            ref="CreateEditPresetModal"
            :team="team"
            :edit-selected-preset="editSelectedPreset"
            :create-edit-preset-text-obj="createEditPresetTextObj"
            v-on:preset-saved="presetSaved">
        </create-edit-preset-modal>
    </b-container>
</template>

<script>
import CreateEditPresetModal from "../preset/create-edit-preset-modal.vue";

export default {
    name: 'permission-sets-tab',
    components: {CreateEditPresetModal},
    props: ['team'],
    data() {
        return {
            presets: [],
            pagination: {
                meta: {},
                links: {}
            },
            filter: {
                search: null,
                timeout: null
            },
            presetsLoader: false,
            createEditPresetTextObj: {
                modalTitle: '',
                saveBtnText: 'Create'
            },
            editSelectedPreset: null
        }
    },
    mounted() {
        this.getTeamAllPresets();
    },
    methods: {
        getTeamAllPresets(page = 1) {
              let self = this;
              self.presetsLoader = true;
              const payload = {
                  page,
                  search: this.filter.search
              };

            axios.get('/settings/'+this.team.id+'/permissions/roles/all', {params: payload}).then(({data}) => {
                self.presets = data.data;
                self.pagination.links = data.links;
                self.pagination.meta = data.meta;
                self.presetsLoader = false;
            }).catch((error) => {
                self.presetsLoader = false;
            });
        },
        debounceFilter() {
            clearTimeout(this.filter.timeout);
            this.filter.timeout = setTimeout(() => {
                this.getTeamAllPresets();
            }, 700, this);
        },
        goToPage(page) {
            this.getTeamAllPresets(page);
        },
        createPreset() {
            this.createEditPresetTextObj.modalTitle = 'Create Preset';
            this.createEditPresetTextObj.saveBtnText = 'Create';
            this.$refs.CreateEditPresetModal.open();
        },
        editPreset(preset) {
            this.createEditPresetTextObj.modalTitle = 'Edit Preset';
            this.createEditPresetTextObj.saveBtnText = 'Update';
            this.editSelectedPreset = preset;
            this.$refs.CreateEditPresetModal.open();
        },
        presetSaved() {
            this.getTeamAllPresets();
        },
        deletePreset(preset) {
            Swal.fire({
                title: 'Are you sure you want to delete ' + preset.name + ' preset?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    axios.post('/settings/'+this.team.id+'/permissions/roles/delete', {id: preset.id}).then((response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: preset.name + ' preset deleted successfully.'
                        });
                        this.getTeamAllPresets();
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.search-container {
    position: relative;
}
.search-container i {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}
.min-w-25 {
    min-width: 25%;
}
.list-group-item {
    background-color: #e7ebef;
    padding: 10px;
    border-radius: 3px;
    margin-bottom: 8px;
    border: 1px solid #d1d5db;
    box-shadow: 0 2px 3px rgba(55, 63, 67, .16);
}
.no-btn-properties {
    background: none;
    color: #01B1AF;
    border: none;
    box-shadow: none;
}
.loader-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    width: 100%;
    height: 100%;
}
</style>
